@if (breadcrumbs().length > 0) {
  <nav class="breadcrumb-container">
    @for (crumb of breadcrumbs(); track $index; let i = $index) {
      @if (i < breadcrumbs().length - 1) {
        @if (!!crumb.url) {
          <a [routerLink]="crumb.url">{{ crumb.label }}</a>
        } @else {
          <span>{{ crumb.label }}</span>
        }
        <span class="separator">/</span>
      } @else {
        <span class="current">{{ crumb.label }}</span>
      }
    }
  </nav>
}
